import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, AlertIcon } from './styles';

const Alert = ({ children, icon, ...props }) => {
  return (
    <Wrapper {...props}>
      <AlertIcon name={icon} />

      {children}
    </Wrapper>
  );
};

Alert.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  type: PropTypes.oneOf(['success', 'default', 'info', 'danger', 'badge']),
  outline: PropTypes.bool,
  fontSize: PropTypes.string,
  labelSize: PropTypes.string,
  lineHeight: PropTypes.string,
  icon: PropTypes.node,
  border: PropTypes.oneOf([null, 'right', 'left', 'bottom', 'top']),
};

Alert.defaultProps = {
  type: 'default',
  fontSize: '16',
  lineHeight: '24',
  outline: false,
  icon: null,
  children: null,
  labelSize: null,
  border: null,
};

export default Alert;
